<div class="lm-columns-percent-row">
  @for (col of columns; track trackByIndex($index, col)) {
    <div class="lm-columns-percent-column" [ngStyle]="{'width.%': (col.percent * 100)}">
      @if (col) {
        <lm-element
          [layoutObject]="col"
          [layoutInfo]="layoutInfo"
          [lmColumnLayoutInfo]="lmColumnLayoutInfo"
          [specFields]="specFields"
          [placeHolder]="placeHolder"
          [model]="model"
          (fieldEvent)="onFieldEvent($event)"
        ></lm-element>
      }
    </div>
  }
</div>

